// extracted by mini-css-extract-plugin
module.exports = {"localeDropdown":"LangSelect_localeDropdown__0tDzz","item":"LangSelect_item__M0MbX"};